"use strict";
exports.__esModule = true;
function generateSeries(dataRows, legends, zindex) {
    if (zindex === void 0) { zindex = 6; }
    var series = [];
    var _loop_1 = function (legend) {
        var tagKey = legend['tag'];
        var tagColor = legend['color'];
        var seriesData = dataRows.filter(function (item) {
            return item.colorTag === tagKey && typeof item.y !== 'undefined';
        });
        if (seriesData.length > 0) {
            series.push({
                'name': tagKey,
                'color': tagColor,
                'zIndex': zindex,
                'data': seriesData
            });
        }
    };
    for (var _i = 0, legends_1 = legends; _i < legends_1.length; _i++) {
        var legend = legends_1[_i];
        _loop_1(legend);
    }
    return series;
}
function getRadialDividerSeries(radialDividers) {
    var ans = [];
    if (radialDividers.length > 0) {
        for (var i = 0; i < radialDividers.length; i++) {
            var r = Number(radialDividers[i]);
            var data = [];
            for (var x = 0; x < r; x += 0.05) {
                var y = Math.sqrt(Math.pow(r, 2) - Math.pow(x, 2));
                data.push([x, y]);
            }
            ans.push({
                data: data,
                type: 'spline',
                color: '#AEAEAE',
                showInLegend: false,
                enableMouseTracking: false
            });
        }
    }
    return ans;
}
function getChartOptions(graph, options) {
    var chartTitle = options.chartTitle, _a = options.legends, legends = _a.legends, siblingLegends = _a.siblingLegends, settings = options.settings, timestamp = options.timestamp;
    var mainSeriesData = graph.mainRows.sort(function (a, b) { return a.x - b.x; });
    var siblingSeriesData = (graph.siblingRows || []).sort(function (a, b) { return a.x - b.x; });
    var series = generateSeries(mainSeriesData, legends, 6);
    var drilldown = graph.mainDrillDown;
    if (siblingSeriesData.length > 0) {
        var siblingSeries = generateSeries(siblingSeriesData, siblingLegends, 5);
        series = series.concat(siblingSeries);
        drilldown = drilldown.concat(graph.siblingDrillDown);
    }
    var dividerSeries = getRadialDividerSeries(JSON.parse(graph.radialDivider));
    series = series.concat(dividerSeries);
    var tickPositionsForXAxis = [].concat(JSON.parse(graph.xscale), JSON.parse(graph.xticks)).sort(function (a, b) { return a - b; });
    var tickPositionsForYAxis = [].concat(JSON.parse(graph.yscale), JSON.parse(graph.yticks)).sort(function (a, b) { return a - b; });
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 560,
            width: 580,
            type: 'bubble',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        title: {
            text: chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (this.point.name) {
                    return "<i>" + this.point.name + " (" + this.series.name + ")</i><br />" +
                        (graph.yTitle + ": <b>" + this.point.originy.toFixed(settings.decimals) + "</b><br />") +
                        (graph.xTitle + ": <b>" + this.point.originx.toFixed(settings.decimals) + "</b><br />") +
                        (graph.name + ": <b>" + this.point.z.toFixed(settings.decimals) + "</b>");
                }
                else {
                    return false;
                }
            },
            crosshairs: [true, true]
        },
        xAxis: {
            gridLineWidth: 1,
            min: 0,
            max: 10,
            tickPositions: tickPositionsForXAxis,
            labels: {
                enabled: true
            },
            title: {
                enabled: true,
                text: graph.xTitle
            },
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true
        },
        yAxis: {
            min: 0,
            max: 10,
            tickPositions: tickPositionsForYAxis,
            labels: {
                enabled: true
            },
            title: {
                enabled: true,
                text: graph.yTitle
            }
        },
        plotOptions: {
            bubble: {
                dataLabels: {
                    enabled: settings.showLabel,
                    align: 'right',
                    style: {
                        fontWeight: 'thin',
                        color: 'black'
                    },
                    formatter: function () {
                        return this.point.name.slice(0, settings.charsInLabel);
                    }
                }
            }
        },
        series: series,
        drilldown: {
            series: drilldown
        }
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=bubble-chart.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/bubble-chart2/bubble-chart.chart.js